function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1920(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 38.55,
    height: 19.01,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.37625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.275,
    y: 9.505,
    fontFamily: "Arial"
  }, "\n        Florence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 19.01,
    width: 38.55,
    height: 24.77,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.954
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.275,
    y: 31.395000000000003,
    fontFamily: "Arial"
  }, "\n        Vilas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 43.78,
    width: 38.55,
    height: 34.46,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.743333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.275,
    y: 61.010000000000005,
    fontFamily: "Arial"
  }, "\n        Forest\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 78.24,
    width: 38.55,
    height: 36.37,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.273999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.275,
    y: 96.425,
    fontFamily: "Arial"
  }, "\n        Adams\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 114.61,
    width: 38.55,
    height: 38.12,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.353333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.275,
    y: 133.67,
    fontFamily: "Arial"
  }, "\n        Sawyer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 152.73,
    width: 38.55,
    height: 38.78,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.709999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.275,
    y: 172.12,
    fontFamily: "Arial"
  }, "\n        Pepin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 191.51,
    width: 38.55,
    height: 39.97,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.6375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.275,
    y: 211.495,
    fontFamily: "Arial"
  }, "\n        Iron\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 231.49,
    width: 38.55,
    height: 46.12,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.507142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.275,
    y: 254.55,
    fontFamily: "Arial"
  }, "\n        Burnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 277.6,
    width: 38.55,
    height: 47.76,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.81875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.275,
    y: 301.48,
    fontFamily: "Arial"
  }, "\n        Washburn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 325.37,
    width: 38.55,
    height: 57.91,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.283333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.275,
    y: 354.325,
    fontFamily: "Arial"
  }, "\n        Marquette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 383.28,
    width: 38.55,
    height: 60.27,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.81875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.275,
    y: 413.41499999999996,
    fontFamily: "Arial"
  }, "\n        Kewaunee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 443.55,
    width: 38.55,
    height: 60.92,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.6375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.275,
    y: 474.01,
    fontFamily: "Arial"
  }, "\n        Rusk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 504.47,
    width: 38.55,
    height: 62.66,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.81875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.275,
    y: 535.8000000000001,
    fontFamily: "Arial"
  }, "\n        Bayfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 567.12,
    width: 38.55,
    height: 65.4,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.507142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.275,
    y: 599.82,
    fontFamily: "Arial"
  }, "\n        Buffalo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 632.52,
    width: 38.55,
    height: 67.48,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.275,
    y: 666.26,
    fontFamily: "Arial"
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.55,
    y: 0,
    width: 49.02,
    height: 53.19,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.17
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 63.06,
    y: 26.595,
    fontFamily: "Arial"
  }, "\n        Oneida\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.58,
    y: 0,
    width: 52.9,
    height: 53.19,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.58
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 114.03,
    y: 26.595,
    fontFamily: "Arial"
  }, "\n        Price\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 140.48,
    y: 0,
    width: 55.81,
    height: 53.19,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.598571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 168.385,
    y: 26.595,
    fontFamily: "Arial"
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 196.29,
    y: 0,
    width: 56.75,
    height: 53.19,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.2975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 224.665,
    y: 26.595,
    fontFamily: "Arial"
  }, "\n        Door\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 253.04,
    y: 0,
    width: 60.15,
    height: 53.19,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.319
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 283.115,
    y: 26.595,
    fontFamily: "Arial"
  }, "\n        Green_Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 313.19,
    y: 0,
    width: 61.2,
    height: 53.19,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.598571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 343.79,
    y: 26.595,
    fontFamily: "Arial"
  }, "\n        Ozaukee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 374.38,
    y: 0,
    width: 62.59,
    height: 53.19,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.598571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 405.675,
    y: 26.595,
    fontFamily: "Arial"
  }, "\n        Calumet\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 436.98,
    y: 0,
    width: 63.64,
    height: 53.19,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.64875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 468.8,
    y: 26.595,
    fontFamily: "Arial"
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 500.62,
    y: 0,
    width: 64.39,
    height: 53.19,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.64875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 532.815,
    y: 26.595,
    fontFamily: "Arial"
  }, "\n        Waushara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.01,
    y: 0,
    width: 67.37,
    height: 53.19,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.64875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 598.6949999999999,
    y: 26.595,
    fontFamily: "Arial"
  }, "\n        Richland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 632.38,
    y: 0,
    width: 67.62,
    height: 53.19,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.598571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 666.19,
    y: 26.595,
    fontFamily: "Arial"
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.55,
    y: 53.19,
    width: 63.99,
    height: 58.68,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.78
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.545,
    y: 82.53,
    fontFamily: "Arial"
  }, "\n        Pierce\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.55,
    y: 111.87,
    width: 63.99,
    height: 58.94,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.823333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.545,
    y: 141.34,
    fontFamily: "Arial"
  }, "\n        Juneau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.55,
    y: 170.82,
    width: 63.99,
    height: 61.53,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.593636363636364
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.545,
    y: 201.58499999999998,
    fontFamily: "Arial"
  }, "\n        Trempealeau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.55,
    y: 232.35,
    width: 63.99,
    height: 61.69,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.812857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.545,
    y: 263.195,
    fontFamily: "Arial"
  }, "\n        Ashland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.55,
    y: 294.04,
    width: 63.99,
    height: 64.55,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.99875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.545,
    y: 326.315,
    fontFamily: "Arial"
  }, "\n        Langlade\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.55,
    y: 358.59,
    width: 63.99,
    height: 65.07,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.9975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.545,
    y: 391.125,
    fontFamily: "Arial"
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.55,
    y: 423.66,
    width: 63.99,
    height: 66.14,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.665000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.545,
    y: 456.73,
    fontFamily: "Arial"
  }, "\n        Oconto\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.55,
    y: 489.8,
    width: 63.99,
    height: 69.54,
    style: {
      fill: "#4C0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.9975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.545,
    y: 524.57,
    fontFamily: "Arial"
  }, "\n        Dunn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.55,
    y: 559.34,
    width: 63.99,
    height: 70.19,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.11
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.545,
    y: 594.4350000000001,
    fontFamily: "Arial"
  }, "\n        Lafayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.55,
    y: 629.53,
    width: 63.99,
    height: 70.47,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.798
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.545,
    y: 664.765,
    fontFamily: "Arial"
  }, "\n        Green\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 102.54,
    y: 53.19,
    width: 65.18,
    height: 70.96,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.863333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 135.13,
    y: 88.66999999999999,
    fontFamily: "Arial"
  }, "\n        Vernon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 167.72,
    y: 53.19,
    width: 65.63,
    height: 70.96,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.4075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 200.535,
    y: 88.66999999999999,
    fontFamily: "Arial"
  }, "\n        Iowa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 233.35,
    y: 53.19,
    width: 75.18,
    height: 70.96,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.884444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 270.94,
    y: 88.66999999999999,
    fontFamily: "Arial"
  }, "\n        St._Croix\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 308.53,
    y: 53.19,
    width: 76.27,
    height: 70.96,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.095999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 346.66499999999996,
    y: 88.66999999999999,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 384.81,
    y: 53.19,
    width: 77.11,
    height: 70.96,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.191999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 423.365,
    y: 88.66999999999999,
    fontFamily: "Arial"
  }, "\n        Clark\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 461.92,
    y: 53.19,
    width: 77.92,
    height: 70.96,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.137142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 500.88,
    y: 88.66999999999999,
    fontFamily: "Arial"
  }, "\n        Shawano\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 539.84,
    y: 53.19,
    width: 79.98,
    height: 70.96,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.884444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 579.83,
    y: 88.66999999999999,
    fontFamily: "Arial"
  }, "\n        Marinette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 619.82,
    y: 53.19,
    width: 80.18,
    height: 70.96,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.826666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 659.9100000000001,
    y: 88.66999999999999,
    fontFamily: "Arial"
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 102.54,
    y: 124.15,
    width: 75.88,
    height: 75.26,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.4075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 140.48000000000002,
    y: 161.78,
    fontFamily: "Arial"
  }, "\n        Chippewa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 102.54,
    y: 199.41,
    width: 75.88,
    height: 75.27,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.545
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 140.48000000000002,
    y: 237.045,
    fontFamily: "Arial"
  }, "\n        Barron\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 102.54,
    y: 274.68,
    width: 75.88,
    height: 77.81,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.84
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 140.48000000000002,
    y: 313.58500000000004,
    fontFamily: "Arial"
  }, "\n        Portage\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 102.54,
    y: 352.48,
    width: 75.88,
    height: 81.77,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.485
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 140.48000000000002,
    y: 393.365,
    fontFamily: "Arial"
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 102.54,
    y: 434.25,
    width: 75.88,
    height: 87.66,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.97
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 140.48000000000002,
    y: 478.08,
    fontFamily: "Arial"
  }, "\n        Sauk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 102.54,
    y: 521.91,
    width: 75.88,
    height: 88.61,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.587999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 140.48000000000002,
    y: 566.2149999999999,
    fontFamily: "Arial"
  }, "\n        Eau_Claire\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 102.54,
    y: 610.51,
    width: 75.88,
    height: 89.49,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.97
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 140.48000000000002,
    y: 655.255,
    fontFamily: "Arial"
  }, "\n        Wood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 178.42,
    y: 124.15,
    width: 78.73,
    height: 88.7,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.247142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 217.785,
    y: 168.5,
    fontFamily: "Arial"
  }, "\n        Waupaca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 257.15,
    y: 124.15,
    width: 82.36,
    height: 88.7,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.295
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 298.33,
    y: 168.5,
    fontFamily: "Arial"
  }, "\n        Walworth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 339.52,
    y: 124.15,
    width: 84.55,
    height: 88.7,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.078571428571427
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 381.79499999999996,
    y: 168.5,
    fontFamily: "Arial"
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 424.07,
    y: 124.15,
    width: 86.86,
    height: 88.7,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.651111111111112
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 467.5,
    y: 168.5,
    fontFamily: "Arial"
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 510.93,
    y: 124.15,
    width: 93.8,
    height: 88.7,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.740000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 557.83,
    y: 168.5,
    fontFamily: "Arial"
  }, "\n        Grant\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 604.73,
    y: 124.15,
    width: 95.27,
    height: 88.7,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.0875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 652.365,
    y: 168.5,
    fontFamily: "Arial"
  }, "\n        Waukesha\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 178.42,
    y: 212.85,
    width: 98.66,
    height: 89.1,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.728571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 227.75,
    y: 257.4,
    fontFamily: "Arial"
  }, "\n        Kenosha\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 178.42,
    y: 301.96,
    width: 98.66,
    height: 96.15,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.683333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 227.75,
    y: 350.03499999999997,
    fontFamily: "Arial"
  }, "\n        Manitowoc\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 178.42,
    y: 398.11,
    width: 98.66,
    height: 96.38,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.708888888888888
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 227.75,
    y: 446.3,
    fontFamily: "Arial"
  }, "\n        La_Crosse\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 178.42,
    y: 494.48,
    width: 98.66,
    height: 101.73,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 19.732
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 227.75,
    y: 545.345,
    fontFamily: "Arial"
  }, "\n        Brown\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 178.42,
    y: 596.21,
    width: 98.66,
    height: 103.79,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 19.732
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 227.75,
    y: 648.105,
    fontFamily: "Arial"
  }, "\n        Dodge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 277.08,
    y: 212.85,
    width: 95.04,
    height: 109.63,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.56
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 324.59999999999997,
    y: 267.66499999999996,
    fontFamily: "Arial"
  }, "\n        Outagamie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 372.12,
    y: 212.85,
    width: 107.17,
    height: 109.63,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.742727272727272
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 425.705,
    y: 267.66499999999996,
    fontFamily: "Arial"
  }, "\n        Fond_du_Lac\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 479.29,
    y: 212.85,
    width: 110.29,
    height: 109.63,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.181111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 534.4350000000001,
    y: 267.66499999999996,
    fontFamily: "Arial"
  }, "\n        Winnebago\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 589.58,
    y: 212.85,
    width: 110.42,
    height: 109.63,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.70375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 644.7900000000001,
    y: 267.66499999999996,
    fontFamily: "Arial"
  }, "\n        Marathon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 277.08,
    y: 322.48,
    width: 105.02,
    height: 115.71,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.668888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 329.59,
    y: 380.33500000000004,
    fontFamily: "Arial"
  }, "\n        Sheboygan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 277.08,
    y: 438.2,
    width: 105.02,
    height: 128.63,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 26.255
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 329.59,
    y: 502.515,
    fontFamily: "Arial"
  }, "\n        Rock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 277.08,
    y: 566.82,
    width: 105.02,
    height: 133.18,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.503333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 329.59,
    y: 633.4100000000001,
    fontFamily: "Arial"
  }, "\n        Racine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 382.1,
    y: 322.48,
    width: 317.9,
    height: 64.8,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.2
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 541.05,
    y: 354.88,
    fontFamily: "Arial"
  }, "\n        Dane\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 382.1,
    y: 387.28,
    width: 317.9,
    height: 312.72,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 34.74666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 541.05,
    y: 543.64,
    fontFamily: "Arial"
  }, "\n        Milwaukee\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1920);
export default __webpack_public_path__ + "static/media/1920.afd0cc600878f406a3767224e2199123.svg";
export { ForwardRef as ReactComponent };